import { Link } from "react-router-dom";
import { Lock, Zap, X, Check } from "lucide-react";

/**
 * UpgradeModal — shown when a Free user hits a Pro-gated action server-side
 * (HTTP 402 { code:'upgrade_required', feature, message }).
 *
 * Usage:
 *   <UpgradeModal feature="custom task lists" open={!!gated} onClose={() => setGated(null)} />
 *
 * The Link points to /billing — the user lands there with checkout pre-selectable.
 */
export default function UpgradeModal({ open, feature, message, onClose }) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="upgrade-modal"
    >
      <div className="bg-white border border-zinc-200 w-full max-w-md" onClick={(e) => e.stopPropagation()}>
        <header className="border-b border-zinc-200 px-5 py-4 flex items-center justify-between">
          <h2 className="text-base font-semibold tracking-tight flex items-center gap-2">
            <Lock className="w-4 h-4 text-[#002FA7]" strokeWidth={1.75} />
            Pro feature
          </h2>
          <button onClick={onClose} className="text-zinc-500 hover:text-zinc-900" aria-label="Close" data-testid="upgrade-close">
            <X className="w-4 h-4" />
          </button>
        </header>
        <div className="p-5 space-y-4">
          <p className="text-sm text-zinc-700 leading-relaxed">
            {message || `${feature || "This"} is a Pro feature.`} Start your 14-day trial — no card required — or upgrade now to unlock:
          </p>
          <ul className="space-y-2 text-sm text-zinc-700">
            {[
              "Unlimited custom task lists",
              "Share lists with another user",
              "Share whole workspace",
              "View / Edit / Manage permissions",
            ].map((f) => (
              <li key={f} className="flex items-start gap-2"><Check className="w-4 h-4 mt-0.5 text-emerald-600 shrink-0" /> {f}</li>
            ))}
          </ul>
        </div>
        <footer className="border-t border-zinc-200 px-5 py-3 flex items-center justify-end gap-2">
          <button onClick={onClose} className="px-4 py-2 text-sm text-zinc-700 hover:text-zinc-900" data-testid="upgrade-not-now">
            Not now
          </button>
          <Link
            to="/billing"
            className="inline-flex items-center gap-2 px-5 py-2 bg-zinc-900 hover:bg-[#002FA7] text-white text-xs font-medium uppercase tracking-[0.12em] transition-colors"
            data-testid="upgrade-go-pro"
          >
            <Zap className="w-3.5 h-3.5" /> See Pro plans
          </Link>
        </footer>
      </div>
    </div>
  );
}
